import { TallyMark2Icon } from './TallyMark2Icon';

/**
 * author: Michael Irigoyen
 * id 3324BD04-3F49-4759-9C4E-8C94F513F977
 * name tally-mark-2
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tally-mark-2.svg
 * tags
 * - Math 
 */
export const Counting2Icon = TallyMark2Icon;
export default Counting2Icon